const COMMUNICATION_STAND_FALLBACK = "\u2014";

export const formatCommunicationStandNumberLabel = (value?: string | null): string => {
  const normalizedValue = typeof value === "string" ? value.trim() : "";

  if (!normalizedValue) {
    return COMMUNICATION_STAND_FALLBACK;
  }

  const withoutPrefix = normalizedValue.replace(/^(\u2116\s*|N\s*|#\s*)/iu, "").trim();

  return `\u2116 ${withoutPrefix || normalizedValue}`;
};

export const formatCommunicationStandGroupTitle = (
  value: string | null | undefined,
  fallbackLabel: string
): string => {
  const formattedStandNumber = formatCommunicationStandNumberLabel(value);

  if (formattedStandNumber === COMMUNICATION_STAND_FALLBACK) {
    return fallbackLabel;
  }

  return `STAND ${formattedStandNumber}`;
};
